import { render } from "./AgeticSimpleIcon.vue?vue&type=template&id=dd095db0&ts=true"
import script from "./AgeticSimpleIcon.vue?vue&type=script&lang=ts"
export * from "./AgeticSimpleIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__